import { useAuth } from "@/contexts/AuthContext";
import VisitorLanding from "@/pages/VisitorLanding";

/**
 * Renders the children only if the current user is logged in (admin).
 * Otherwise renders the VisitorLanding page (no redirect, clean URL).
 */
export default function AdminOnlyRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <VisitorLanding />;
  return children;
}
